// TODO - See if this file is needed.
const BOX_MODELS = ['margin', 'border', 'padding'];
const CONTENT_INDEX = -1;
const PADDING_INDEX = 2;
const BORDER_INDEX = 1;
const MARGIN_INDEX = 0;

const cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block',
};

function getClientPosition(elem) {
  let box;
  let x;
  let y;
  const doc = elem.ownerDocument;
  const {body} = doc;
  const docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();

  x = box.left;
  y = box.top;

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y,
  };
}

function getScroll(w, top) {
  let ret = w[`page${top ? 'Y' : 'X'}Offset`];
  const method = `scroll${top ? 'Top' : 'Left'}`;
  if (typeof ret !== 'number') {
    const d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  if (!el) return;
  const pos = getClientPosition(el);
  const doc = el.ownerDocument;
  const w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

function getComputedStyle(elem, name, computedStyle_) {
  let val = '';
  const d = elem.ownerDocument;
  const computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

function isBorderBoxFn(elem) {
  return getComputedStyle(elem, 'boxSizing') === 'border-box';
}

function swap(elem, options, callback) {
  const old = {};
  const {style} = elem;
  let name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  let value = 0;
  for (let j = 0; j < props.length; j++) {
    const prop = props[j];
    if (prop) {
      for (let i = 0; i < which.length; i++) {
        let cssProp;
        if (prop === 'border') {
          cssProp = `${prop + which[i]}Width`;
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyle(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  return obj != null && obj == obj.window;
}

const domUtils = {};

['Width', 'Height'].forEach((name) => {
  domUtils[`doc${name}`] = (refWin) => {
    const d = refWin.document;
    return Math.max(
      d.documentElement[`scroll${name}`],
      d.body[`scroll${name}`],
      domUtils[`viewport${name}`](d)
    );
  };

  domUtils[`viewport${name}`] = (win) => {
    const prop = `client${name}`;
    const doc = win.document;
    const {body} = doc;
    const {documentElement} = doc;
    const documentElementProp = documentElement[prop];
    return (
      (doc.compatMode === 'CSS1Compat' && documentElementProp) ||
      (body && body[prop]) ||
      documentElementProp
    );
  };
});

function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  }
  if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  const which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  let borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  const computedStyle = getComputedStyle(elem);
  const isBorderBox = isBorderBoxFn(elem, computedStyle);
  let cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    cssBoxValue = getComputedStyle(elem, name);
    if (cssBoxValue === null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  const borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  const val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    const padding =
      extra === PADDING_INDEX
        ? -getPBMWidth(elem, ['border'], which, computedStyle)
        : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

function getWHIgnoreDisplay(elem) {
  let val;
  const args = arguments;
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, () => {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  let value = v;
  if (typeof name === 'object') {
    for (const i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyle(el, name);
}

['width', 'height'].forEach((name) => {
  const first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils[`outer${first}`] = (el, includeMargin) =>
    el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  const which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = (elem, val) => {
    if (val !== undefined) {
      if (elem) {
        const computedStyle = getComputedStyle(elem);
        const isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function setOffset(elem, offset) {
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  const old = getOffset(elem);
  const ret = {};
  let current;
  let key;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

function getWindow(node) {
  const doc = node.ownerDocument || node;
  return doc.defaultView || doc.parentWindow;
}

function offset(el, value) {
  if (typeof value !== 'undefined') {
    setOffset(el, value);
  } else {
    return getOffset(el);
  }
}

function scrollLeft(w, v) {
  if (isWindow(w)) {
    if (v === undefined) {
      return getScrollLeft(w);
    }
    window.scrollTo(v, getScrollTop(w));
  } else {
    if (v === undefined) {
      return w.scrollLeft;
    }
    w.scrollLeft = v;
  }
}

function scrollTop(w, v) {
  if (isWindow(w)) {
    if (v === undefined) {
      return getScrollTop(w);
    }
    window.scrollTo(getScrollLeft(w), v);
  } else {
    if (v === undefined) {
      return w.scrollTop;
    }
    w.scrollTop = v;
  }
}

export const util = {
  css,
  offset,
  getWindow,
  isWindow,
  scrollLeft,
  scrollTop,
  ...domUtils,
};

export function scrollIntoView(elem, container, config) {
  config = config || {};
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  let {allowHorizontalScroll} = config;
  const {onlyScrollIfNeeded} = config;
  let {alignWithTop} = config;
  let {alignWithLeft} = config;
  const offsetTop = config.offsetTop || 0;
  const offsetLeft = config.offsetLeft || 0;
  const offsetBottom = config.offsetBottom || 0;
  const offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  const isWin = util.isWindow(container);
  const elemOffset = util.offset(elem);
  if (!elemOffset) return;
  const eh = util.outerHeight(elem);
  const ew = util.outerWidth(elem);
  let containerOffset;
  let ch;
  let cw;
  let containerScroll;
  let diffTop;
  let diffBottom;
  let win;
  let winScroll;
  let ww;
  let wh;
  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win),
    };
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop,
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom,
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop,
    };
    diffTop = {
      left:
        elemOffset.left -
        (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) -
        offsetLeft,
      top:
        elemOffset.top -
        (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) -
        offsetTop,
    };
    diffBottom = {
      left:
        elemOffset.left +
        ew -
        (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) +
        offsetRight,
      top:
        elemOffset.top +
        eh -
        (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) +
        offsetBottom,
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else if (diffTop.top < 0) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    }
  } else if (!onlyScrollIfNeeded) {
    alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
    if (alignWithTop) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else if (diffTop.left < 0) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      }
    } else if (!onlyScrollIfNeeded) {
      alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
      if (alignWithLeft) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      }
    }
  }
}

export function smoothScroll(elem, offset = 0, time) {
  const pos = elem.offsetTop - offset;

  if (isNaN(pos)) {
    throw 'Position must be a number';
  }
  if (pos < 0) {
    throw 'Position can not be negative';
  }
  const currentPos = window.scrollY || window.screenTop;
  if (currentPos < pos) {
    if (time) {
      var x;
      var i = currentPos;
      x = setInterval(() => {
        window.scrollTo(0, i);
        i += 10;
        if (i >= pos) {
          clearInterval(x);
        }
      }, time);
    } else {
      let t = 10;
      for (let i = currentPos; i <= pos; i += 10) {
        t += 10;
        setTimeout(() => {
          window.scrollTo(0, i);
        }, t / 2);
      }
    }
  } else {
    time = time || 2;
    var i = currentPos;
    var x;
    x = setInterval(() => {
      window.scrollTo(0, i);
      if (i <= pos) {
        clearInterval(x);
      }
      i -= 10;
    }, time);
  }
}
